import { createAction } from 'Helpers';
import commentifyTypes from './types';

const commentsActions = {
	getCommentsRequest: createAction(commentifyTypes.NEWEST_COMMENTS.REQUEST),
	getCommentsSuccess: createAction(commentifyTypes.NEWEST_COMMENTS.SUCCESS),
	getCommentsFailure: createAction(commentifyTypes.NEWEST_COMMENTS.FAILURE),
	getCommentsClear: createAction(commentifyTypes.NEWEST_COMMENTS.CLEAR),

	commentsReplyRequest: createAction(commentifyTypes.REPLY.REQUEST),
	commentsReplySuccess: createAction(commentifyTypes.REPLY.SUCCESS),
	commentsReplyFailure: createAction(commentifyTypes.REPLY.FAILURE),
	commentsReplyClear: createAction(commentifyTypes.REPLY.CLEAR),
};

export default commentsActions;
